angular.module('gym.components').directive('waiverPrivacyPolicySection', function() {
  return {
    restrict: 'EA',
    scope: {
      waiver: '=',
      privacyPolicyResponses: '=',
      readOnly: '=',
      internal: '='
    },
    template: require('templates/components/waivers/waiver_privacy_policy_section.html.slim'),
    controller: ["$scope", function($scope) {
      return $scope.isGDPREnabled = function() {
        var form;
        form = $scope.waiver.signed_waiver_form_attributes;
        return form.contact_age_check_privacy_policy_checkbox_active || form.contact_information_privacy_policy_checkbox_active;
      };
    }]
  };
});
